export const useDisplayRegisterLink = (): boolean => {
  if (typeof window !== 'undefined') {
    const searchParameters = window.location.search;
    if (searchParameters && searchParameters.includes('displayRegisterLink=false')) {
      sessionStorage.setItem('displayRegisterLink', 'false');
    }

    const registerLinkIsDisabled = sessionStorage.getItem('displayRegisterLink') === 'false';

    return !registerLinkIsDisabled;
  }
  return true;
};
